import { Button } from '@/shared/ui/button'
import React from 'react'
import { ShowMoreProps } from '../show-more'
import withShowMore from './show-more.hoc'

export type ComponentProps = {
  defaultVisibleItems?: ShowMoreProps['defaultVisibleItems']
  renderAction?: ShowMoreProps['renderItem']
} & ShowMoreProps

export default function Component(props: ComponentProps) {
  return withShowMore({
    ...props,
    defaultVisibleItems: props?.defaultVisibleItems || 1,
    renderAction: ({ isMore, isReset, noMore, more, reset }) => {
      if (noMore) return null
      const isMoreText = isMore && 'Читать полностью'
      const isResetText = isReset && 'Свернуть'
      return (
        <Button
          type="button"
          className="mt-2"
          variant="ghost"
          onClick={() => {
            isMore && more()
            isReset && reset()
          }}
        >
          {isMoreText || isResetText}
        </Button>
      )
    },
  })
}
